<template>
    <el-drawer title="隐私信息" :visible.sync="visible" direction="rtl" size="900px" :append-to-body="true"
        custom-class="privacy-drawer">
        <div class="privacy-drawer-body" v-loading="loading">
            <div class="privacy-header" v-if="basicInfo">
                <h3 class="privacy-name">{{ basicInfo.nickName || '-' }}</h3>
                <div class="privacy-tags">
                    <span class="info-tag">
                        <i class="el-icon-phone tag-icon"></i>
                        {{ basicInfo.phone || '-' }}
                    </span>
                    <span class="info-tag" v-if="basicInfo.idCardNumber">
                        <i class="el-icon-postcard tag-icon"></i>
                        {{ basicInfo.idCardNumber || '-' }}
                    </span>
                    <span class="info-tag" v-if="ageLabel">
                        <i class="el-icon-date tag-icon"></i>
                        {{ ageLabel }}
                    </span>
                    <span class="info-tag" v-if="sexLabel">
                        <i class="el-icon-user tag-icon"></i>
                        {{ sexLabel }}
                    </span>
                </div>
            </div>

            <el-tabs v-model="activeTab" class="privacy-tabs" @tab-click="onTabClick">
                <el-tab-pane label="基本信息" name="basic">
                    <div class="info-section" v-if="basicInfo">
                        <div class="section-title">
                            <span class="title-line"></span>
                            基本信息
                        </div>
                        <el-row :gutter="20" class="info-row">
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">客户姓名</div>
                                    <div class="info-value">{{ basicInfo.nickName || '-' }}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">手机号码</div>
                                    <div class="info-value">{{ basicInfo.phone || '-' }}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">身份证号</div>
                                    <div class="info-value">{{ basicInfo.idCardNumber || '-' }}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">电子邮箱</div>
                                    <div class="info-value">{{ basicInfo.email || '-' }}</div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" class="info-row">
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">所属分组</div>
                                    <div class="info-value">
                                        <span v-if="basicInfo.groupName">{{ basicInfo.groupName }}</span>
                                        <span v-else class="text-warning">未设置</span>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">注册时间</div>
                                    <div class="info-value">{{ formatDateTime(basicInfo.createdTime) }}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">最后登录时间</div>
                                    <div class="info-value">{{ formatDateTime(basicInfo.lastLoginTime) }}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">状态</div>
                                    <div class="info-value">
                                        <span v-if="isNormalStatus" class="status-tag status-success">正常</span>
                                        <span v-else class="status-tag status-danger">禁用</span>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="info-section top-border" v-if="showRealnameInfo">
                        <div class="section-title">
                            <span class="title-line"></span>
                            实名信息
                        </div>
                        <el-row :gutter="20" class="info-row">
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">真实姓名</div>
                                    <div class="info-value">{{ realnameInfo.realName || '-' }}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">性别</div>
                                    <div class="info-value">{{ sexLabel }}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">身份证号</div>
                                    <div class="info-value">{{ realnameInfo.idCardNumber || '-' }}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="info-item">
                                    <div class="info-label">证件有效期至</div>
                                    <div class="info-value">{{ realnameInfo.idCardValidPeriod || '-' }}</div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" class="info-row image-row">
                            <el-col :span="6" v-if="realnameInfo.idCardFront">
                                <div class="image-item">
                                    <div class="image-label">身份证人像面</div>
                                    <el-image :src="realnameInfo.idCardFront"
                                        :preview-src-list="realnamePreviewList" fit="cover"
                                        class="idcard-image"></el-image>
                                </div>
                            </el-col>
                            <el-col :span="6" v-if="realnameInfo.idCardBack">
                                <div class="image-item">
                                    <div class="image-label">身份证国徽面</div>
                                    <el-image :src="realnameInfo.idCardBack"
                                        :preview-src-list="realnamePreviewList" fit="cover"
                                        class="idcard-image"></el-image>
                                </div>
                            </el-col>
                            <el-col :span="6" v-if="realnameInfo.facePhoto">
                                <div class="image-item">
                                    <div class="image-label">首次人脸照</div>
                                    <el-image :src="realnameInfo.facePhoto" :preview-src-list="realnamePreviewList"
                                        fit="cover" class="idcard-image"></el-image>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="登录记录" name="loginRecord" v-if="enableFriendInsight">
                    <el-table v-loading="loginRecordLoading" :data="loginRecordList"
                        :row-class-name="loginRecordRowClass">
                        <el-table-column label="登录IP" prop="loginIp" min-width="130" align="center">
                        </el-table-column>
                        <el-table-column label="登录时间" prop="loginTime" min-width="160" align="center">
                            <template v-slot="{ row }">
                                {{ formatDateTime(row.loginTime) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="登录地址" prop="loginAddress" min-width="150" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column label="设备类型" prop="deviceType" min-width="120" align="center">
                        </el-table-column>
                        <el-table-column label="设备型号" prop="deviceOs" min-width="120" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column label="登录结果" prop="loginResult" min-width="100" align="center">
                            <template v-slot="{ row }">
                                <span v-if="isSuccess(row.loginResult)" class="status-tag status-success">成功</span>
                                <span v-else class="status-tag status-danger">失败</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination v-if="loginRecordTotal > 0"
                        :current-page.sync="loginRecordQuery.pageNum"
                        :page-size="loginRecordQuery.pageSize" :total="loginRecordTotal"
                        layout="total, prev, pager, next" @current-change="loadLoginRecords"
                        class="pagination-bar">
                    </el-pagination>
                </el-tab-pane>

                <el-tab-pane label="人脸记录" name="faceLog">
                    <el-table v-loading="faceLogLoading" :data="faceLogList">
                        <el-table-column label="认证ID" prop="certifyId" min-width="140" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column label="IP地址" prop="ip" min-width="130" align="center">
                        </el-table-column>
                        <el-table-column label="人脸照片" prop="facePhoto" min-width="100" align="center">
                            <template v-slot="{ row }">
                                <el-image v-if="row.facePhoto" :src="row.facePhoto"
                                    :preview-src-list="[row.facePhoto]" fit="cover" class="face-image">
                                </el-image>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="发起时间" prop="createTime" min-width="160" align="center">
                            <template v-slot="{ row }">
                                {{ formatDateTime(row.createTime) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="认证状态" prop="passed" min-width="100" align="center">
                            <template v-slot="{ row }">
                                <span v-if="isSuccess(row.passed)" class="status-tag status-success">成功</span>
                                <span v-else class="status-tag status-danger">失败</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="失败原因" prop="failReason" min-width="150" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                    </el-table>
                    <el-pagination v-if="faceLogTotal > 0" :current-page.sync="faceLogQuery.pageNum"
                        :page-size="faceLogQuery.pageSize" :total="faceLogTotal" layout="total, prev, pager, next"
                        @current-change="loadFaceLogs" class="pagination-bar">
                    </el-pagination>
                </el-tab-pane>

                <el-tab-pane label="通讯录记录" name="contact">
                    <div class="contact-table-wrap">
                        <el-table v-loading="contactLoading" :data="contactListLeft"
                            :row-class-name="contactRowClass" class="contact-half-table">
                            <el-table-column label="姓名" prop="contactName" align="center">
                            </el-table-column>
                            <el-table-column label="手机号码" prop="phone" align="center">
                            </el-table-column>
                            <el-table-column label="归属地" prop="location" align="center"
                                show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                        <el-table :data="contactListRight"
                            :row-class-name="contactRowClass" class="contact-half-table">
                            <el-table-column label="姓名" prop="contactName" align="center">
                            </el-table-column>
                            <el-table-column label="手机号码" prop="phone" align="center">
                            </el-table-column>
                            <el-table-column label="归属地" prop="location" align="center"
                                show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination v-if="contactTotal > 0" :current-page.sync="contactQuery.pageNum"
                        :page-size="contactQuery.pageSize" :total="contactTotal" layout="total, prev, pager, next"
                        @current-change="loadContacts" class="pagination-bar">
                    </el-pagination>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-drawer>
</template>

<script>
export default {
    name: "PrivacyDrawer",
    data() {
        return {
            visible: false,
            friendId: null,
            activeTab: "basic",
            loading: false,
            basicInfo: null,

            loginRecordLoading: false,
            loginRecordList: [],
            loginRecordTotal: 0,
            loginRecordQuery: {
                pageNum: 1,
                pageSize: 10
            },

            faceLogLoading: false,
            faceLogList: [],
            faceLogTotal: 0,
            faceLogQuery: {
                pageNum: 1,
                pageSize: 10
            },

            contactLoading: false,
            contactList: [],
            contactTotal: 0,
            contactQuery: {
                pageNum: 1,
                pageSize: 20
            }
        }
    },
    computed: {
        enableFriendInsight() {
            return this.userStore.userInfo.enableFriendInsight;
        },
        sexLabel() {
            const sex = this.basicInfo && this.basicInfo.sex;
            if (sex === 0) return "男";
            if (sex === 1) return "女";
            return (this.basicInfo && this.basicInfo.sexText) || "";
        },
        ageLabel() {
            if (this.basicInfo && this.basicInfo.age) {
                return this.basicInfo.age;
            }
            return this.getAge(this.basicInfo && this.basicInfo.idCardNumber) || "";
        },
        isNormalStatus() {
            const status = this.basicInfo && this.basicInfo.status;
            if (status === undefined || status === null || status === "" ||
                status === 0 || status === false ||
                status === "NORMAL" || status === "ENABLED" || status === "正常") {
                return true;
            }
            return false;
        },
        realnameInfo() {
            return (this.basicInfo && this.basicInfo.realnameAuth) || {};
        },
        showRealnameInfo() {
            return this.realnameInfo && (this.realnameInfo.realName || this.realnameInfo.idCardNumber);
        },
        realnamePreviewList() {
            const info = this.realnameInfo || {};
            return [info.idCardFront, info.idCardBack, info.facePhoto].filter(Boolean);
        },
        contactListLeft() {
            const half = Math.ceil(this.contactList.length / 2);
            return this.contactList.slice(0, half);
        },
        contactListRight() {
            const half = Math.ceil(this.contactList.length / 2);
            return this.contactList.slice(half);
        },
    },
    methods: {
        open(friendId, tab) {
            this.friendId = friendId;
            this.visible = true;
            this.reset();
            if (tab) {
                this.activeTab = tab;
            }
            this.loadBasicInfo();
            if (tab && tab !== 'basic') {
                this.loadTabData(tab);
            }
        },
        reset() {
            this.activeTab = "basic";
            this.basicInfo = null;
            this.loginRecordList = [];
            this.loginRecordTotal = 0;
            this.loginRecordQuery.pageNum = 1;
            this.faceLogList = [];
            this.faceLogTotal = 0;
            this.faceLogQuery.pageNum = 1;
            this.contactList = [];
            this.contactTotal = 0;
            this.contactQuery.pageNum = 1;
        },
        close() {
            this.visible = false;
        },
        onTabClick(tab) {
            this.loadTabData(tab.name);
        },
        loadTabData(tabName) {
            if (tabName === "loginRecord") {
                this.loadLoginRecords();
            } else if (tabName === "faceLog") {
                this.loadFaceLogs();
            } else if (tabName === "contact") {
                this.loadContacts();
            }
        },
        loadBasicInfo() {
            if (!this.friendId) return;
            this.loading = true;
            this.$http({
                url: `/friend/insight/${this.friendId}`,
                method: "GET"
            }).then((res) => {
                this.basicInfo = this.extractData(res) || {};
            }).catch(() => {
                this.basicInfo = {};
            }).finally(() => {
                this.loading = false;
            });
        },
        loadLoginRecords() {
            if (!this.friendId) return;
            this.loginRecordLoading = true;
            this.$http({
                url: `/friend/insight/${this.friendId}/loginRecords`,
                method: "GET",
                params: {
                    page: this.loginRecordQuery.pageNum,
                    size: this.loginRecordQuery.pageSize
                }
            }).then((res) => {
                const page = this.extractPage(res);
                this.loginRecordList = page.rows;
                this.loginRecordTotal = page.total;
            }).finally(() => {
                this.loginRecordLoading = false;
            });
        },
        loadFaceLogs() {
            if (!this.friendId) return;
            this.faceLogLoading = true;
            this.$http({
                url: `/friend/insight/${this.friendId}/faceLogs`,
                method: "GET",
                params: {
                    page: this.faceLogQuery.pageNum,
                    size: this.faceLogQuery.pageSize
                }
            }).then((res) => {
                const page = this.extractPage(res);
                this.faceLogList = page.rows;
                this.faceLogTotal = page.total;
            }).finally(() => {
                this.faceLogLoading = false;
            });
        },
        loadContacts() {
            if (!this.friendId) return;
            this.contactLoading = true;
            this.$http({
                url: `/friend/insight/${this.friendId}/contacts`,
                method: "GET",
                params: {
                    page: this.contactQuery.pageNum,
                    size: this.contactQuery.pageSize
                }
            }).then((res) => {
                const page = this.extractPage(res);
                this.contactList = page.rows;
                this.contactTotal = page.total;
            }).finally(() => {
                this.contactLoading = false;
            });
        },
        extractData(res) {
            if (res && res.data !== undefined && res.data !== null) {
                return res.data;
            }
            return res;
        },
        extractPage(res) {
            if (!res) {
                return { rows: [], total: 0 };
            }
            const data = this.extractData(res);
            if (Array.isArray(data)) {
                return { rows: data, total: data.length };
            }
            return {
                rows: data.rows || data.list || data.content || data.records || data.data || [],
                total: data.total || data.totalElements || data.totalCount || 0
            };
        },
        isSuccess(value) {
            return value === 1 || value === true || value === "SUCCESS";
        },
        loginRecordRowClass({ row }) {
            return row.highlight === true ? 'contact-overlap-highlight' : '';
        },
        contactRowClass({ row }) {
            return row.overlapHighlight === true ? 'contact-overlap-highlight' : '';
        },
        getAge(idCard) {
            if (!idCard || idCard.length !== 18) {
                return null;
            }
            const birthStr = idCard.substring(6, 14);
            const year = parseInt(birthStr.substring(0, 4), 10);
            const month = parseInt(birthStr.substring(4, 6), 10);
            const day = parseInt(birthStr.substring(6, 8), 10);
            const now = new Date();
            let age = now.getFullYear() - year;
            if (now.getMonth() + 1 < month || (now.getMonth() + 1 === month && now.getDate() < day)) {
                age--;
            }
            return age > 0 ? age : null;
        },
        formatDateTime(date) {
            if (!date) {
                return "-";
            }
            const d = new Date(date);
            if (isNaN(d.getTime())) {
                return date;
            }
            const pad = (n) => (n < 10 ? "0" + n : n);
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        }
    }
}
</script>

<style scoped lang="scss">
.privacy-drawer-body {
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    .privacy-header {
        padding: 32px 24px;
        .privacy-name {
            margin: 0 0 24px;
            font-size: 28px;
            font-weight: bold;
            color: var(--im-text-color);
        }

        .privacy-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 48px;
            .info-tag {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                font-size: 16px;
                .tag-icon {
                    color: #c0c4cc;
                }
            }
        }
    }

    .privacy-tabs {
        ::v-deep .el-tabs__header {
            margin-bottom: 0;
            .el-tabs__nav-wrap {
                .el-tabs__item {
                    font-size: 18px;
                    padding: 0 24px;
                    height: 60px;
                    line-height: 60px;
                    font-weight: initial;
                    &.is-active {
                        font-weight: bold;
                    }
                }
                &::after {
                    background-color: rgba(216,223,235,0.25);
                    height: 1px;
                }
                .el-tabs__active-bar {
                    border-radius: 4px;
                    height: 4px;
                    padding: 0 24px;
                    box-sizing: border-box;
                    background-color: transparent;
                    bottom: 5px;
                    &::after {
                        content: '';
                        width: 40px;
                        height: 4px;
                        background: #1F5AFF;
                        border-radius: 4px;
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: 0;
                    }
                }
            }
        }
        .info-section {
            padding: 24px;
            &.top-border{
                border-top: 8px solid #FAFBFC;
            }
            .section-title {
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 15px;
                font-weight: 600;
                color: var(--im-text-color);
                margin-bottom: 20px;
                .title-line {
                    width: 4px;
                    height: 16px;
                    background: linear-gradient( 180deg, #1F5AFF 0%, #3385FF 100%), #D8D8D8;
                    border-radius: 24px;
                }
            }

            .info-row {
                margin-bottom: 16px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .info-item {
                .info-label {
                    font-size: 13px;
                    color: var(--im-text-color-light);
                    margin-bottom: 6px;
                }

                .info-value {
                    font-size: 14px;
                    color: var(--im-text-color);
                    word-break: break-all;

                    .text-warning {
                        color: #FF6933;
                    }
                }
            }

            .image-row {
                .image-item {
                    .image-label {
                        font-size: 13px;
                        color: var(--im-text-color-light);
                        margin-bottom: 8px;
                    }

                    .idcard-image {
                        width: 100%;
                        height: 120px;
                        border-radius: 6px;
                        background: #f5f7fa;
                        cursor: pointer;
                    }
                }
            }
        }

        .face-image {
            width: 60px;
            height: 60px;
            border-radius: 4px;
            background: #f5f7fa;
            cursor: pointer;
        }

        .pagination-bar {
            margin-top: 16px;
            text-align: right;
        }

        .contact-table-wrap {
            display: flex;
            gap: 16px;

            .contact-half-table {
                flex: 1;
                min-width: 0;
            }
        }
    }
}

.status-tag {
    display: inline-block;
    padding: 0 10px;
    height: 24px;
    line-height: 22px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid;
    box-sizing: border-box;
    white-space: nowrap;

    &.status-success {
        color: #67c23a;
        background: #f0f9eb;
        border-color: #e1f3d8;
    }

    &.status-danger {
        color: #f56c6c;
        background: #fef0f0;
        border-color: #fde2e2;
    }
}
</style>
<style lang="scss">
.contact-overlap-highlight {
    background: rgba(255, 105, 51, 0.04);
    color: #FF6933;

    td {
        background: rgba(255, 105, 51, 0.04);
        color: #FF6933;
    }
}

.privacy-drawer {
    .el-table th.el-table__cell {
        background-color: #F7F9FC;
        color: #1F1F1F;
        font-weight: initial;
    }
}
</style>